export function applyFarsiDocument() {
  document.documentElement.dir = 'rtl';
  document.documentElement.lang = 'fa';
  document.title = 'آشیانه';
  localStorage.removeItem('language');
}
